import Link from 'next/link';
import { FC, ReactNode } from 'react';
import { IoChevronForward } from 'react-icons/io5';

import { Box, Text, UnstyledButton } from '@mantine/core';

import cx from './ProfileCard.module.scss';

const ProfileCard: FC<{
    image: ReactNode;
    imageFit?: 'cover' | 'contain';
    eyebrow?: ReactNode;
    eyebrowIcon?: ReactNode;
    title: ReactNode;
    meta?: ReactNode;
    description?: ReactNode;
    cta?: string;
    href?: string;
    target?: string;
    onClick?: () => void;
    actions?: ReactNode;
}> = ({
    image,
    imageFit = 'cover',
    eyebrow,
    eyebrowIcon,
    title,
    meta,
    description,
    cta = 'View details',
    href,
    target,
    onClick,
    actions,
}) => (
    <Box className={cx.card}>
        <Box className={cx.image} data-fit={imageFit}>
            {image}
        </Box>

        {actions && <Box className={cx.actions}>{actions}</Box>}

        <Box className={cx.body}>
            {eyebrow && (
                <Box className={cx.eyebrow}>
                    {eyebrowIcon && <Box className={cx.eyebrowIcon}>{eyebrowIcon}</Box>}
                    <Text component="span" className={cx.eyebrowText}>
                        {eyebrow}
                    </Text>
                </Box>
            )}

            {href ? (
                <Link href={href} target={target} className={cx.title}>
                    {title}
                </Link>
            ) : onClick ? (
                <UnstyledButton onClick={onClick} className={cx.title}>
                    {title}
                </UnstyledButton>
            ) : (
                <Text className={cx.title} data-static>
                    {title}
                </Text>
            )}

            {meta && <Box className={cx.meta}>{meta}</Box>}

            {description && (
                <Text component="div" className={cx.description} lineClamp={3}>
                    {description}
                </Text>
            )}

            {(href || onClick) && (
                <Text className={cx.cta}>
                    {cta}
                    <IoChevronForward />
                </Text>
            )}
        </Box>
    </Box>
);

export { ProfileCard };
